<template>
  <div class="title-circle-box">
    <div class="title" :style="`margin-top:${top}rem`">
      <span>{{ title }}</span>
      <img
        class="zIndex-1 circle-bg"
        src="@/assets/imgs/press-center/yuan-bg.webp"
        alt=""
      />
    </div>
    <div class="subtitle">{{ title2 }}</div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
    },
    title2: {
      type: String,
    },
    top: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
.title-circle-box {
  display: inline-block;
  .title {
    position: relative;
    display: inline-block;
    margin-top: 0.47rem;
    font-size: 0.46rem;
    font-family: FZLanTingHeiS-B-GB;
    font-weight: 400;
    color: #000000;
    line-height: 0.46rem;
    span{
      position: relative;
      z-index: 2;
    }
    img {
      position: absolute;
      top: -0.17rem;
      right: -0.13rem;
      width: 0.3rem;
      height: 0.3rem;
      z-index: 1;
    }
  }
  .subtitle {
    margin-top: 0.23rem;
    font-size: 0.26rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    line-height: 0.28rem;
  }
}
@media screen and (max-width: 768px){
  .title-circle-box {
    .title{
      display: block;
      font-family: SourceHanSansCN-Bold;
      font-size: 0.23rem;
      color: #000000;
      line-height: 0.24rem;
      img{
        top: -0.06rem;
        right: -0.06rem;
        width: 0.15rem;
        height: 0.15rem;
      }
    }
    .subtitle{
      display: none;
    }
  }
}
</style>